import type { MutableRefObject } from 'react'
import { useRef } from 'react'
import type { Control } from 'react-hook-form'
import { useFormState } from 'react-hook-form'
import type { AssignmentFormValues } from 'pages/instructor/slide_deck/AssignmentDialog/schemas'

/**
 * Tracks whether the late submission cutoff currently in the form was derived
 * from the due date rather than picked by the instructor.
 *
 * The due date derives the cutoff (due + 1 week) for as long as the cutoff is
 * ours to derive. An assignment that was saved with a cutoff starts out
 * instructor-owned, so editing its due date must not silently overwrite it -
 * react-hook-form's `dirtyFields` cannot express this, since a value loaded
 * from the database arrives as a (clean) default value.
 */
export function useCutoffIsAutoDerived(
  control: Control<AssignmentFormValues>
): MutableRefObject<boolean> {
  const { defaultValues } = useFormState({ control })
  return useRef(!defaultValues?.lateSubmissionCutoff)
}
